import { Project, projectHasDocument } from '@guiker/real-estate-shared'

import { PropertySaleListing } from '../entity'

export const hasDocument = (listing: PropertySaleListing, project?: Project) => {
  return (listing.documents && listing.documents.length) || projectHasDocument(project)
}
